function ExpandedNoticeModal({ expandedNotice, onClose }) {
  if (!expandedNotice) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-900/35 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <h3 className="text-base font-bold text-slate-900">{expandedNotice.title}</h3>
        <div className="mt-3 max-h-[45vh] overflow-auto rounded-lg border border-slate-200 bg-slate-50 p-3">
          <p className="whitespace-pre-wrap break-words text-sm text-slate-700">{expandedNotice.message}</p>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            className="rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white transition hover:bg-slate-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExpandedNoticeModal;
